import { useMemo } from 'react'
import * as con from '../../GlobalConstants'
import { parseDate } from '../../utils/dateFunctions'
import { RefApplicationParameterHook } from './ApplicationParametersHooks'

export const useForwardAssessmentFilterFun = () => {
    
    const refDate = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_REFERENCE_DATE);
    const startDate = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_START_DATE);
    const includeActive = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_SHOW_ACTIVE_COVERAGES);
    const includeExpired = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_SHOW_EXPIRED_COVERAGES);
    const includePurchases = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_INCLUDE_PURCHASES);
    const includeSales = RefApplicationParameterHook(con.FORWARD_ASSESSMENT_INCLUDE_SALES);

    return useMemo(() => {
        return (fwd) => {
            const openingDate = parseDate(fwd[con.OPENING_DATE]);
            const expirationDate = parseDate(fwd[con.EXPIRATION_DATE]);

            let resp = openingDate <= refDate;

            const isActive = expirationDate > refDate;

            const hasStart = startDate !== undefined && startDate !== null;
            const lowerBoundOk = hasStart ? (expirationDate >= startDate) : true;
            const isExpiredInRange = lowerBoundOk && (expirationDate <= refDate);

            resp = resp && ((isActive && !!includeActive) || (isExpiredInRange && !!includeExpired));

            if (fwd[con.COVERAGE_TYPE] === con.BUY)
                resp = resp && includePurchases;

            if (fwd[con.COVERAGE_TYPE] === con.SELL)
                resp = resp && includeSales;

            return resp;
        }
    }, [refDate,
        startDate,
        includeActive,
        includeExpired,
        includePurchases,
        includeSales,
       ])
}

export const useOptionAssessmentFilterFun = () => {
    
    const refDate = RefApplicationParameterHook(con.OPTION_ASSESSMENT_REFERENCE_DATE)
    const startDate = RefApplicationParameterHook(con.OPTION_ASSESSMENT_START_DATE)
    const includeActive = RefApplicationParameterHook(con.OPTION_ASSESSMENT_SHOW_ACTIVE_COVERAGES)
    const includeExpired = RefApplicationParameterHook(con.OPTION_ASSESSMENT_SHOW_EXPIRED_COVERAGES)
    const includePurchases = RefApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_PURCHASES)
    const includeSales = RefApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_SALES)
    const includeCall = RefApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_CALL)
    const includePut = RefApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_PUT)

    return useMemo(() => {
        return (option) => {
            const openingDate = parseDate(option[con.OPENING_DATE])
            const expirationDate = parseDate(option[con.EXPIRATION_DATE])

            let resp = openingDate <= refDate

            const isActive = expirationDate > refDate

            const hasStart = startDate !== undefined && startDate !== null
            const lowerBoundOk = hasStart ? (expirationDate >= startDate) : true
            const isExpiredInRange = lowerBoundOk && (expirationDate <= refDate)

            resp = resp && ((isActive && !!includeActive) || (isExpiredInRange && !!includeExpired))

            if (option[con.COVERAGE_TYPE] === con.BUY)
                resp = resp && includePurchases

            if (option[con.COVERAGE_TYPE] === con.SELL)
                resp = resp && includeSales

            if (option[con.OPTION_TYPE] === con.CALL)
                resp = resp && includeCall

            if (option[con.OPTION_TYPE] === con.PUT)
                resp = resp && includePut

            return resp
        }
    }, [refDate,
        startDate,
        includeActive,
        includeExpired,
        includePurchases,
        includeSales,
        includeCall,
        includePut,
    ])
}